import React, { useEffect, useState } from 'react'
import PipeCreatorColumn from './PipeCreatorColumn'
import axios from 'axios';
import '../../css/pipeline.css'
import {  useNavigate } from 'react-router-dom';
export default function PipeCreatorContainer(props) {

   const navigate = useNavigate();
   const [data,setData] =  useState([]);
   const [satatus, setSatatus] = useState('wait');
   const [refresh, setRefresh] = useState('0');
   let lastUrl = '';


   useEffect(() => {
      if(satatus === 'none'){

      }else if(satatus === 'wait'){
       
      }else if(satatus === 'done'){
     
      }else if(satatus === 'error'){
        
      }else if(satatus === 'forbidden'){
      
      }else if(satatus === 'timeout'){
        
      }
    }, [satatus]);

    const onRefresh = () => {

      if(refresh!=='1'){

        setRefresh('1');
      }else{

        setRefresh('0');
      }
    }

    useEffect(()=>{

      onRefresh();
    },[props.refresh])
   useEffect(()=>{
  
    if(lastUrl == props.url || (props.url && props.url.includes('.'))) {
      return;
    }
      setData([]);
      lastUrl = props.url;
      axios.get(props.url, { withCredentials: true })
      .then(response => {
        

        setData(response.data);
        setSatatus('none');
      })
      .catch(err => {
        setSatatus('error');
        console.log(err);
      });
   },[refresh])

  return (
    <div className='pipe-container'>
      { data && Array.isArray(data) && data.length > 0? (
               data.map(item => (

                  <PipeCreatorColumn stages={data} stateHundler={props.stateHundler}  conversationId={props.conversationId}
                  key={item.id} id={item.id} title={item.name} color={item.color} 
                  onRefresh={onRefresh} refresh={refresh} url='/api/stages'></PipeCreatorColumn>

               ))
            ) : (
               <div></div>
         )}
    </div>
  )
}
